import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import './ReservasAdminLayout.css';

export default function ReservasAdminLayout() {
  const navigate = useNavigate();

  return (
    <div className="ra-layout">
      <aside className="ra-sidebar">
        <div className="ra-brand" onClick={() => navigate('/dashboard/owner')}>
          <div className="ra-logo">P</div>
          <div className="ra-brandText">
            <div className="ra-title">Palmarama</div>
            <div className="ra-subtitle">Panel de Reservas</div>
          </div>
        </div>

        <nav className="ra-nav" aria-label="Configuración de reservas">
          <NavLink end to="/admin/reservas" className={({ isActive }) => (isActive ? 'ra-link is-active' : 'ra-link')}>
            Paquetes
          </NavLink>
          <NavLink to="/admin/reservas/listas" className={({ isActive }) => (isActive ? 'ra-link is-active' : 'ra-link')}>
            Listas (Viernes / Sábado / Especial)
          </NavLink>
          <NavLink to="/admin/reservas/eventos" className={({ isActive }) => (isActive ? 'ra-link is-active' : 'ra-link')}>
            Asignar listas a eventos
          </NavLink>
        </nav>

        <div className="ra-sidebarFooter">
          <button className="ra-ghost" onClick={() => navigate('/dashboard/reservas')}>
            Ir al mapa de reservas
          </button>
          <button className="ra-ghost" onClick={() => navigate('/dashboard/owner')}>
            Volver al dashboard
          </button>
        </div>
      </aside>

      <main className="ra-main">
        <header className="ra-topbar">
          <div className="ra-topbarLeft">
            <div className="ra-h1">Configuración de Reservas</div>
            <div className="ra-hint">
              Define paquetes, listas por día y qué lista usa cada evento.
            </div>
          </div>
        </header>

        <div className="ra-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
